@for (modal of this.openModals(); track modal.id; let i = $index) {
    <app-modal-host [modal]="modal" [zIndex]="i + this.baseModalZIndex"/>
}
